import { BiteLogLoyaltyEvent } from './bite_log_loyalty_event.js';

export function name(event: BiteLogLoyaltyEvent): string {
  switch (event) {
    case BiteLogLoyaltyEvent.OK:
      return 'ok';
    case BiteLogLoyaltyEvent.Authed:
      return 'authed';
    case BiteLogLoyaltyEvent.AuthError:
      return 'auth-error';
    case BiteLogLoyaltyEvent.AuthSkipped:
      return 'auth-skipped';
    case BiteLogLoyaltyEvent.RewardsFetched:
      return 'rewards-fetched';
    case BiteLogLoyaltyEvent.RewardsFetchError:
      return 'rewards-fetch-error';
    case BiteLogLoyaltyEvent.RewardsFetchSkipped:
      return 'rewards-fetch-skipped';
    case BiteLogLoyaltyEvent.RewardsApplied:
      return 'rewards-applied';
    case BiteLogLoyaltyEvent.RewardsApplyBestEffortFailed:
      return 'rewards-best-effort-failed';
    case BiteLogLoyaltyEvent.RewardsApplyError:
      return 'rewards-apply-error';
    case BiteLogLoyaltyEvent.RewardsApplySkipped:
      return 'rewards-apply-skipped';
    case BiteLogLoyaltyEvent.RewardRemoved:
      return 'reward-removed';
    case BiteLogLoyaltyEvent.RewardRemoveError:
      return 'reward-remove-error';
    case BiteLogLoyaltyEvent.RewardRemoveSkipped:
      return 'reward-remove-skipped';
    case BiteLogLoyaltyEvent.GiftCardInquiry:
      return 'gift-card-balance-inquiry';
    case BiteLogLoyaltyEvent.GiftCardInquiryError:
      return 'gift-card-inquiry-error';
    case BiteLogLoyaltyEvent.GiftCardInquirySkipped:
      return 'gift-card-inquiry-skipped';
    case BiteLogLoyaltyEvent.GiftCardApplied:
      return 'gift-card-applied';
    case BiteLogLoyaltyEvent.GiftCardApplyError:
      return 'gift-card-apply-error';
    case BiteLogLoyaltyEvent.GiftCardApplySkipped:
      return 'gift-card-apply-skipped';
    case BiteLogLoyaltyEvent.GiftCardRefunded:
      return 'gift-card-refunded';
    case BiteLogLoyaltyEvent.GiftCardRefundError:
      return 'gift-card-refund-error';
    case BiteLogLoyaltyEvent.GiftCardRefundSkipped:
      return 'gift-card-refund-skipped';
    case BiteLogLoyaltyEvent.CouponApplied:
      return 'coupon-applied';
    case BiteLogLoyaltyEvent.CouponApplyError:
      return 'coupon-apply-error';
    case BiteLogLoyaltyEvent.CouponApplySkipped:
      return 'coupon-apply-skipped';
    case BiteLogLoyaltyEvent.CouponRemoved:
      return 'coupon-removed';
    case BiteLogLoyaltyEvent.CouponRemoveError:
      return 'coupon-remove-error';
    case BiteLogLoyaltyEvent.CouponRemoveSkipped:
      return 'coupon-remove-skipped';
    case BiteLogLoyaltyEvent.CouponSingleRedemptionRedeemed:
      return 'coupon-single-redemption-redeemed';
    case BiteLogLoyaltyEvent.CompCardApplied:
      return 'comp-card-applied';
    case BiteLogLoyaltyEvent.CompCardApplyError:
      return 'comp-card-apply-error';
    case BiteLogLoyaltyEvent.CompCardRemoved:
      return 'comp-card-removed';
    case BiteLogLoyaltyEvent.CompCardRemoveError:
      return 'comp-card-remove-error';
    case BiteLogLoyaltyEvent.LoyaltyFailedToCheckin:
      return 'loyalty-failed-to-check-in';
    case BiteLogLoyaltyEvent.RewardCodeRedeemed:
      return 'reward-code-redeemed';
    case BiteLogLoyaltyEvent.RewardCodeRedeemError:
      return 'reward-code-redeem-error';
    case BiteLogLoyaltyEvent.RewardCodeRedeemSkipped:
      return 'reward-code-redeem-skipped';
    case BiteLogLoyaltyEvent.TipRedeemedOnLoyalty:
      return 'tip-redeemed-on-loyalty';
    case BiteLogLoyaltyEvent.TipRedeemOnLoyaltyError:
      return 'tip-redeem-on-loyalty-error';
    case BiteLogLoyaltyEvent.RewardFetchedOnLoyalty:
      return 'reward-fetched-on-loyalty';
    case BiteLogLoyaltyEvent.RewardFetchedOnLoyaltyError:
      return 'reward-fetched-on-loyalty-error';
    case BiteLogLoyaltyEvent.LoyaltySignUpError:
      return 'loyalty-sign-up-error';
  }
}
